import 'dayjs/locale/en'
import 'dayjs/locale/ja'
import 'dayjs/locale/ko'

import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)
// 로케일 내장 장형 날짜 포맷(LL/LT 등) 토큰 사용
dayjs.extend(localizedFormat)
dayjs.locale('en')

export const DEFAULT_TIMEZONE = 'Asia/Seoul'

export { dayjs }
